"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Order_1 = require("./Order");
var Filter_1 = require("./Filter");
var Page_1 = require("./Page");
var GetItemsParams = (function () {
    function GetItemsParams(page, filter, order, statFields) {
        this.page = (page instanceof Page_1.Page) ? page : new Page_1.Page(page);
        this.filter = (filter instanceof Filter_1.Filter) ? filter : new Filter_1.Filter(filter);
        this.order = (order instanceof Order_1.OrderClauses) ? order : new Order_1.OrderClauses(order);
        this.statFields = statFields ? statFields : [];
    }
    GetItemsParams.prototype.withPage = function (page) {
        return new GetItemsParams(page, this.filter, this.order);
    };
    GetItemsParams.prototype.from = function (startIndex) {
        return this.withPage(this.page.from(startIndex));
    };
    GetItemsParams.prototype.size = function (maxItems) {
        return this.withPage(this.page.size(maxItems));
    };
    /*
     Up to but including the given index
     */
    GetItemsParams.prototype.to = function (endIndex) {
        return this.withPage(this.page.to(endIndex));
    };
    GetItemsParams.prototype.next = function (numberOfItems) {
        return this.withPage(this.page.next(numberOfItems));
    };
    GetItemsParams.prototype.withFilter = function (filter) {
        return new GetItemsParams(this.page, filter, this.order);
    };
    GetItemsParams.prototype.and = function (leafClauseFilter) {
        return this.withFilter(this.filter.and(leafClauseFilter));
    };
    GetItemsParams.prototype.withOrder = function (order) {
        return new GetItemsParams(this.page, this.filter, order);
    };
    GetItemsParams.prototype.prependAscField = function (field) {
        return this.withOrder(this.order.prependAscField(field));
    };
    GetItemsParams.prototype.prependDescField = function (field) {
        return this.withOrder(this.order.prependDescField(field));
    };
    return GetItemsParams;
}());
exports.GetItemsParams = GetItemsParams;
//# sourceMappingURL=GetItemsParams.js.map